import script from "./ApplicationSettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationSettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationSettingsView.vue?vue&type=style&index=0&id=03f27898&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f27898"]])

export default __exports__